import { getMeasureTitleByKey, getMeasureNameByKey } from '../shared/measureUtils';
import {
    ALL_MEASURES,
    getBurstMeasureTitleByKey,
    getBurstMeasureNameByKey,
} from '../../constants/reading/MeasuresConstants';

export const getMeasureTitle = measure => ({
    measureTitle: getMeasureTitleByKey(ALL_MEASURES, measure) || getBurstMeasureTitleByKey(measure),
    measureName: getMeasureNameByKey(ALL_MEASURES, measure) || getBurstMeasureNameByKey(measure),
});

export default getMeasureTitle;
